{
  "JudgeJoinModalTitle": "Welcome to ",
  "JudgeJoinModalPhrase1": "We are honored to have you as a judge.",
  "JudgeJoinModalPhrase2": "Let the contestants and event-goers know who you are.",
  "UploadProfilePic": "upload profile pic",
  "TitlePlaceholder": "title",
  "BioPlaceholder": "tell us about your beautiful self",
  "BioNewPlaceholder": "Please tell the event attendees about yourself. We recommend sharing your recent accomplishments, your passions, and why you're the fairest in all the land.",
  "SkipForLater": "skip for later",
  "SubmitButton": "Submit",
  "JudgeWelcomeRemark": "Looking forward to your verdict.. err... I mean evaluation.",
  "WelcomJudge": "Hub Event - Welcome Judge",
  "ResourceJoinModalPhrase1": "Let the contestants know how you can help.",
  "labelPlaceholder": "area of expertise",
  "WelcomSupport": "Hub Event - Welcome Support",
  "NoProjectsYet": "You don't have any projects yet.",
  "SelectProjectLater": "select project later",
  "SubmitProject": "submit my project",
  "CreateHubModal": "Create Hub Modal",
  "CreateProject": "Create a project",
  "SelectProjectTitle": "Select Project for ",
  "SelectProjectToCompete": "Select Project to compete in",
  "CurrentlySubmitted": "Currently Submitted:",
  "SelectProjectFormPhrase1": "All",
  "SelectProjectFormPhrase1Part2": "team members will get an invite",
  "SelectProjectFormPhrase2": "You have no other project to change to.",
  "ok": "Ok",
  "BackToGroup": "back to group",
  "BuilderSchedule": "Builder Schedule",
  "AddBuilders": "add builders",
  "UnsavedSheduleMessage": "You have an unsaved schedule. Are you sure to proceed?",
  "Cancel": "Cancel",
  "Remove": "Remove",
  "RemoveHubMemberText": "Are you sure you want to remove this member from your Hub?",
  "RemoveHubGroupMemberText": "Are you sure you want to remove this member from your Hub Group? ",
  "Save": "Save",
  "inactive": "inactive",
  "Projects": "Projects",
  "NoProjects": "There are no projects here yet!",
  "Members": "Members",
  "SearchMembers": "search members",
  "SeeMoreMembers": "see more members",
  "Managers": "Managers",
  "AddedToGroupHeader": "You were added to the group:",
  "AddedToGroupMessage": "was automatically added to it, too.",
  "AddedToGroupHint": "Hint: you can switch your project anytime in the group page.",
  "Okay": "Okay!",
  "RemoveProject": "Remove project",
  "SwitchProject": "Switch project",
  "GroupNameTakenError": "Group name has already been taken!",
  "NoResultsFound": "No results found",
  "NoGroupsYet": "You have no groups yet.",
  "HubGroupSubscriptionHeader": "Your Subscription Plan Allows for",
  "HubGroupSubscriptionHeaderPart2": "active groups",
  "HubGroupSubscriptionMessage": "Upgrade to unlock unlimited active groups",
  "HubGroupSubscriptionHint": "Hint: you can deactivate other group to make room for this one",
  "Upgrade": "Upgrade",
  "SelectImage": "Select image",
  "Image": "Image",
  "Preview": "Preview",
  "add": "Add",
  "AddVideoFromURL": "Add video from URL",
  "ActivityMediaModal": "Activity Media Modal",
  "VideoURLPlaceholder": "Paste video link here",
  "VideoNotSupportedMessage": "Sorry, your browser doesn't support embedded videos.",
  "AnnouncementInputPlaceholder": "Let all your members know (they will get a notification)",
  "sticky": "Sticky",
  "announce": "announce",
  "PostInputPlaceholder": "Share your thoughts",
  "post": "Post",
  "OfferInputPlaceholder": "How can you help? Don't forget to add how people can contact you/your availability",
  "offer": "Offer",
  "*required": "*required",
  "QuestionInputPlaceholder": "Add question here",
  "QuestionInputOptionalPlaceholder": "Optional: include details or reference link.",
  "ask": "ask",
  "IdeaInputPlaceholder": "Add your idea",
  "IdeaDetailInputPlaceholder": "Describe your problem and solution in more detail",
  "CreatePost": "Create a post",
  "MakeAnnouncement": "Make an announcement",
  "MakeOffer": "Make an offer",
  "AddIdea": "Add an idea",
  "AskQuestion": "Ask a question",
  "question": "Question",
  "idea": "Idea",
  "announcement": "Announcement",
  "General": "General",
  "FormerRebel": "Former Rebel",
  "kudos": "kudos",
  "brainstorm": "brainstorm",
  "brainstorms": "brainstorms",
  "answer": "answer",
  "1reply": "Reply",
  "replies": "Replies",
  "reply": "reply...",
  "delete": "delete",
  "ReadMore": "read more",
  "ShowLess": "show less",
  "unstick": "Unstick",
  "edit": "Edit",
  "Q+A": "Q+A",
  "VotedBestAnswer": "Voted Best Answer",
  "upvote": "upvote",
  "IdeaSphere": "Idea Sphere",
  "Offers": "Offers",
  "ConfirmDeletion": "Are you sure you want to delete this?",
  "Delete": "Delete",
  "NoGoBack": "No, go back",
  "YesDelete": "Yes, delete",
  "PostedByMe": "Posted By Me",
  "FillAllFields": "Please fill all fields.",
  "YouCanOnlySelectUpto5Images": "You can only select upto 5 images",
  "TypeHere": "type here!",
  "Brainstorm": "Brainstorm",
  "IdeaBrainstormsPhrase": "Is this the type of idea YOU like to geek out over? Share what you think could take this idea to the next level.",
  "AddToBrainstorm": "Add to Brainstorm",
  "NothingHereYet": "nothing here yet..",
  "Questions": "Questions",
  "IdeaQuestionsPhrase": "Does a piece of this idea have you befuddled? Ask burning questions, poke holes, file missing logic reports, demand supporting evidence.",
  "AddToQuestions": "Add to Questions",
  "IdeaOffersPhrase": "Want to see this project go the full length? Contribute any talents or resources or refer them to someone that could give them a leg up.",
  "AddToOffers": "Add to Offers",
  "backToActivities": "back to activities",
  "ConfirmIdeaDeletion": "Are you sure you want to delete this idea?",
  "support": "Support",
  "AnswerDetailPlaceholder": "share your knowledge",
  "Question": "Question",
  "Answer": "Answer",
  "Answers": "Answers",
  "OtherAnswers": "Other Answers",
  "NoAnswers": "No Answers",
  "NoOtherAnswers": "No other answers.",
  "FirstToAnswer": "Be the first to answer this question!",
  "ConfirmQuestionDeletion": "Are you sure you want to delete this question?",
  "Pending": "Pending",
  "NoPendingInvitations": "No pending invitations",
  "SeeAll": "see all",
  "sent": "sent",
  "SendNudge": "send nudge",
  "InviteMembers": "Invite Members",
  "BrainTitle": "Welcome to Brain",
  "BrainPhrase1Part1": "Be in the know.",
  "BrainPhrase1Part2": "This is your snapshot of what is happening in your hub",
  "hubGuide": "Hub Guide",
  "rebelBaseHub101": "RebelBase Hub 101",
  "projectsBuilders": "Projects + Builders",
  "collaboration": "Collaboration",
  "inviteToYour": "Invite to Your Hub",
  "events": "Events",
  "onboardCohorts": "Onboard Cohorts",
  "troubleshooting": "Troubleshooting",
  "SuccesfullySent": "Succesfully sent",
  "invite": "invite",
  "invites": "invites",
  "to": "to",
  "AlreadyMember": "Already a member",
  "already member": "Already a member",
  "AlreadyInvited": "Already invited",
  "already invited": "Already Invited",
  "gel": "gel",
  "NudgeSent": "Nudge sent!",
  "ClickHere": "Click here",
  "ClickHerePart2": "to send them a nudge.",
  "ErrorSending": "Opps! Error sending",
  "ThisEmail": "this email",
  "TheseEmails": "these emails",
  "SelectRoles": "Select role(s):",
  "Rebel": "Rebel",
  "WorkingOnInnovation": "working on innovation",
  "Supporter": "Supporter",
  "LendingExpertise": "lending expertise to rebel",
  "NoRole": "no role",
  "InviteViaEmails": "Invite via emails",
  "InviteViaEmailsPart2": "Use a comma or space to separate multiple email addresses",
  "PersonalizeInvitation": "Personalize your invitation with a message",
  "AddYourMessage": "Add your message",
  "optional": "optional",
  "SendInvite": "Send Invite",
  "HubInviteTitle": "Invite Members to ",
  "Hub": "Hub",
  "InviteHubMembersModal": "Invite Hub Members Modal",
  "PendingInvites": "Pending Invites",
  "NoPendingInvitation": "There are no pending invitations.",
  "HubPendingInvitationsModal": "Hub Pending Invitations Modal",
  "LocationPlaceholder": "Search for your city here",
  "CreateYourHub": "Create Your Hub",
  "Location": "Location",
  "Type": "Type",
  "SelectType": "select a type",
  "Website": "Website",
  "Working": "Working...",
  "Next": "Next",
  "SkipForNow": "skip for now",
  "Done": "Done",
  "SelectLogo": "select logo",
  "LogoHint": "JPG, PNG or GIF, up to 5 MB.",
  "CreateHubStepTwoTitle": "Give Us Some Details - Make Your Space Pop",
  "Logo": "Logo",
  "Description": "Description",
  "DescriptionPlaceholder": "Add a 1-3 sentence description about your hub. (250 max characters)",
  "EventsCase1": "Only you participated",
  "EventsCase1Part2": "Only you are participating",
  "You": "You",
  "Participated": "participated",
  "Participants": "participants",
  "Participant": "participant",
  "Online": "Online",
  "Activity": "Activity",
  "Event": "Event",
  "EventsCountOne": "{{count}} event",
  "EventsCountOther": "{{count}} events",
  "NewEvent": "New Event",
  "Public": "Public",
  "PastEvents": "Past events",
  "NoEventsYet": "There are no events yet.",
  "CreateNewEvent": "create a new event.",
  "RoleAt": "Role at",
  "AdminCardModal": "Admin Card Modal",
  "SelectProjectsForHub": "Select Projects for Hub",
  "YouHaveNoProjects": "You have no projects.",
  "ClickHereToCreateProject": "Click here to create a project.",
  "RebelCardModal": "Rebel Card Modal",
  "WhatAreYourPowers": "What are your powers? (max 10)",
  "PowerExamples": "i.e., finance, risk awareness, branding...",
  "PressEnterToAddTag": "press enter to add tag",
  "BestWayToContactYou": "Best way to contact you",
  "ContactPlaceholder": "i.e., cher@email.com, 888-0782, Cafeteria 2pm on Wednesdays",
  "SupportCardModal": "Support Card Modal",
  "HubAdmin": "Hub Admin",
  "EditAdminRoleCard": "edit admin role card",
  "Project": "Project",
  "noProjects": "no projects",
  "EditRebelRoleCard": "edit rebel role card",
  "Powers": "Powers",
  "NoPowers": "No powers",
  "HowToContact": "How to contact",
  "NoContactInformation": "no contact information",
  "EditSupportRoleCard": "edit support role card",
  "admin": "admin",
  "EditMembership": "Edit Membership",
  "EditHubMembershipModal": "Edit Hub Membership Modal",
  "HubJoinModal": "Hub Join Modal",
  "HubJoinModalPhrase1": "Interact with a community teeming with brilliance, creativity, and innovation. The hub is where you can help others with their projects, find resources to help you with your own, and enter in competitive events to see how you stack up.",
  "HubJoinModalPhrase2": "Introduce yourself in the activity feed.",
  "HubJoinModalPhrase3": "Go ahead and get started",
  "HubJoinModalPhraseCallToAction": "Fill out your info below to let other members get to know you.",
  "ContinueToHub": "continue to hub",
  "HowToContactMe": "How to contact me",
  "EmptyRebelCardPhrase1": "you have not submitted any projects",
  "EmptyRebelCardPhrase2": "add projects to the hub by editing your hub membership",
  "Partner": "Partner",
  "Organization": "Organization",
  "PartnerCardPhrase1": "Advisor, Ted Talk",
  "PartnerCardPhrase2": "Submit applications to be part if New School Ted X by Sept 01.",
  "Judge": "Judge",
  "EventHistory": "Event History",
  "JudgeCardPhrase1": "Apr'14: Post It Demo Day",
  "Bio": "Bio",
  "JudgeCardPhrase2": "Worked here. Worked there. Ya know.",
  "GoTo": "Go to",
  "your": "your",
  "profile": "profile",
  "MembershipModal": "Membership Modal",
  "NoPowersYet": "no powers yet",
  "NothingToSeeHere": "nothing to see here",
  "SearchByName": "search by name",
  "SearchGroups": "search groups",
  "AllTypes": "All types",
  "NewestFirst": "Newest first",
  "OldestFirst": "Oldest first",
  "Upcoming": "Upcoming",
  "Manage": "Manage",
  "Other": "Other",
  "NoDate": "No date",
  "filterAll": "All",
  "filterActive": "Active",
  "filterInactive": "Inactive",
  "activeGroups": "Active groups",
  "inactiveGroups": "Inactive groups",
  "allGroups": "All",
  "sortBy": "Sort",
  "sortMostMembers": "Most members",
  "sortName": "Name",
  "filters": "filters",
  "Admins": "Admins",
  "NoMembersFound": "No members found.",
  "NoHubMembers": "No hub members.",
  "ResendInvite": "Resend Invite",
  "EditHubModal": "Edit Hub Modal",
  "ChangeHubDetails": "Change Hub Details",
  "EditHubDescriptionPlaceholder": "Add a 1-3 sentence description about your project. 250 max characters",
  "Saving": "Saving",
  "ChangeLogo": "change logo",
  "member": "member",
  "EditMyRole": "Edit my role(s)",
  "HideHeader": "hide header",
  "ShowHeader": "show header",
  "or": "or",
  "InactiveSubscription": "This Hub Subscription is Inactive",
  "InactiveSubscriptionMessage": "Your access to the hub will be limited. If you feel this is a mistake, contact them to renew.",
  "SubscriptionExpired": "Your Subscription has Expired",
  "SubscriptionExpiredMessage": "Your access to hub is now limited. Please renew by contacting us.",
  "ContactUs": "Contact Us",
  "HubAdminSubscriptionExpireTitle": "Your Hub Subscription Expired",
  "HubAdminSubscriptionExpireMessage": "Your access to this hub is now limited. Please contact us to renew your subscription to regain full access to this hub",
  "HubMemberSubscriptionExpireTitle": "This Hub Subscription is Inactive",
  "HubMemberSubscriptionExpireMessage": "Your access to this hub is limited. If you feel this is a mistake, please contact the hub administrator",
  "PhotoLimit": "Great photo but it exceeded the max size: 3mb.",
  "SupportedFormats": "Image format not supported. Supported formats are jpg, jpeg, png, gif and jfif.",
  "MaxPhotoSize": "Great photo but it exceeded the max size: 5mb.",
  "MaxLimitError": "Max limit for description is 250 characters",
  "YouAre": "You are",
  "an": "an",
  "a": "a",
  "YourEvents": "Your Events",
  "editGroupName": "edit group name",
  "editMembers": "edit members",
  "editManagers": "edit managers",
  "InviteMembersTo": "Invite Members to",
  "MyEvents": "My Events",
  "AddImage": "Add an image",
  "AddThoughts": "Add your thoughts",
  "GoBack": "Go Back",
  "ChoostPostType": "Choose Post Type",
  "postDesc": "General thoughts",
  "ideaDesc": "Add your ideas for others to contribute to",
  "questionDesc": "Ask a question and collect answers",
  "offerDesc": "Offer your skills and expertise to the community",
  "announcementDesc": "Announce it and all members will get a notification",
  "postCreatedSuccessfully": "Post created successfully",
  "createdSuccessfully": "created successfully",
  "invitePeople": "Invite People",
  "inviteSentMsg": "Your invites have been sent!",
  "InviteRemoveMsg": "Your Invites have been removed",
  "errorSendingInviteMsg": "There were issues with some of the emails you provided, for more details",
  "errorMessage": "Error Message",
  "errorSendingInvites": "Error Sending Invites",
  "Last7days": "Last 7 days",
  "ShowAll": "Show All",
  "SortBy": "Sort By:",
  "Last30Days": "Last 30 days",
  "Last90Days": "Last 90 days",
  "SearchByMail": "Search by Email",
  "SearchInvitations": "Search Invitations",
  "SelectAll": "Select All",
  "DeselectAll": "Deselect All",
  "ResendAllInvites": "Resend All Invites",
  "ResendInvite ": "Resend Invite",
  "ResendSelectedInvites": "Resend Selected Invites",
  "DeleteSelectedInvites": "Delete selected invites",
  "UserManagement": "User Management",
  "SearchHubMembers": "Search Hub Members",
  "SearchByNameOrEmail": "Search members by name or email",
  "View": "View",
  "AllMembers": "All Members",
  "OwnerAdminsOnly": "Owner/Admin's Only",
  "Owner": "Owner",
  "Member": "Member",
  "Admin": "Admin",
  "MembersOnly": "Member's Only",
  "RecentlyJoined": "Recently Joined",
  "AzLastName": "A-Z (Last Name)",
  "ZaLastName": "Z- A (Last Name)",
  "NoActiveInvitations": "No active invitations",
  "NoActiveMembers": "No active members",
  "AddByEmails": "Add by email(s)",
  "createGroup": "Create group",
  "searchByNameOrEmail": "Search by name or email",
  "searchGroupMembers": "Search Group Members",
  "hostsAndManagers": "Hosts + Managers",
  "members": "Members",
  "pendingMembers": "Pending Members",
  "addPeopleToGroup": "Add People to this Group",
  "addMembersByEmail": "Add Hub Members by Email",
  "addMembers": "Add members",
  "membersDirectory": "Members Directory",
  "NoBuildersAvailable": "There are no Builders to display",
  "HubMembers": "Hub Members",
  "Activities": "Activities",
  "Groups": "Groups",
  "Events": "Events",
  "shareAllYourWork": "Share all your hard work and get helpful feedback from your group facilitator and your peers by creating or adding an existing project to this group.",
  "createNewProjectFromScratch": "Create a new project from scratch",
  "createNewProject": "Create New Project",
  "chooseExistingProject": "Choose an existing project to add to your group",
  "addExistingProject": "Add Existing Project",
  "addAnExistingProject": "Add An Existing Project",
  "chooseAnExisitngProjectToAddTo": "Choose an existing project to add to",
  "addProject": "Add Project",
  "ManageMembers": "Manage Members",
  "SearchByNameAndPowers": "Search by Name or Power",
  "ReturnToMemberView": "Return to Rebel View",
  "invalidEmail": "Please enter a valid email address",
  "errorUpdatingMemberRole": "Error updating member role",
  "memberRoleUpdatedSuccessfully": "Member role updated successfully",
  "errorDeletingInvite": "Error deleting invite",
  "errorRemovingMember": "Error removing member",
  "successfullyDeletedInvite": "Successfully deleted invite",
  "memberRemovedSuccessfully": "Member removed successfully",
  "invitesResentSuccessfully": "Invites resent successfully",
  "errorLoadingHubMembers": "Error loading Hub Members",
  "HubSettingsSubtitle": "Hub Settings",
  "Member": "member",
  "Replace": "Replace",
  "SaveChanges": "Save changes",
  "HubNameLabel": "Hub name",
  "HubNameImmutableHint": "Contact support to change your hub's name.",
  "TaglineLabel": "Tagline",
  "HubIdentityTitle": "Hub identity",
  "HubIdentityDescription": "How your hub is introduced across RebelBase \u2014 in search, invitations and member dashboards.",
  "LocationTypeTitle": "Location & type",
  "LocationTypeDescription": "Where your hub is based and what kind of organization it is.",
  "GeneralTab": "General",
  "MembersAndRolesTab": "Members & roles",
  "HubSettingsTabsLabel": "Hub settings sections",
  "NoChangesYet": "No changes yet",
  "UnsavedChanges": "Unsaved changes",
  "AllChangesSaved": "All changes saved"
}